import { customFetch } from 'utils/http';
import {
  HTTPResponseError,
  PassworMatchLoginError,
  TokenExpirationError,
} from 'utils/errors';
import { m8ErrorMessageMap } from 'services/production/utils/constants';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  token: string;
  password: string;
};

export const setUserPassword = async (params: Params) => {
  const { password, token } = params;

  const fetchURL = getM8AuthURL('setUserPassword');

  const body = new FormData();

  body.append('token', token);
  body.append('password', password);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    if (response.status === 400) {
      const data = await response.json();

      if (
        data.message === m8ErrorMessageMap.PASSWOR_MUSTNT_BE_EQUAL_LOGIN ||
        data.message === m8ErrorMessageMap.PASSWOR_MUSTNT_BE_MATCH_LOGIN_PART
      ) {
        throw new PassworMatchLoginError();
      }

      if (data.message === m8ErrorMessageMap.TOKEN_EXPIRATION) {
        throw new TokenExpirationError();
      }
    }

    throw new HTTPResponseError(response);
  }
};
